module.exports = {
  theme: {
    fontFamily: {
      body: "YakuHanMP, 'M PLUS Rounded 1c', sans-serif",
      display: "'Oswald', sans-serif",
      bebas: "'Bebas Neue', sans-serif"
    },
    extend: {
      screens: {
        pt: { raw: "(orientation: portrait)" },
        ls: { raw: "(orientation: landscape)" }
      },
      colors: {
        navy: "#222f66",
        lightCyan: "#11DDFF",
        cyan: "#11aaee",
        bolt: "#eeff66",
        foul: "#ee7777",
        kindai: "#00507e"
      },
      boxShadow: {
        xl: "0 16px 32px -4px rgba(0, 0, 0, .5)",
        "2xl": "0 24px 48px -6px rgba(0, 0, 0, .5)",
        "3xl": "0 32px 64px -8px rgba(0, 0, 0, .5)"
      },
      zIndex: {
        "100": 100
      }
    }
  },
  variants: {},
  plugins: []
};
